import roleTypes from "../types/role";
import { config } from "../../config";

export const initialState = {
  rolelist: [],
  invitelist: [],
  isroleLoading: false,
  referencelist: [],
  addroles: [],
  editrole: [],
  deleterole: {},
  addinvite: [],
  editinvite: [],
  deleteinvite: [],
  sendinvite: [],
  expireDate: [],
  roledetails: [],
  candidateinvitelist: [],
  generatedate: [],
  invitecandidatedetails: [],
  detailsinvite: [],
  roleCategories: {
    architect: "R&D / Architect",
    development: "Engineering / Development",
    other: "Other (IT, Support, DevOps, QE)",
  },
  rolefilter: {
    createdBy: [],
    category: ["Engineering / Development", "R&D / Architect", "Other (IT, Support, DevOps, QE)"],
    skills: [],
    status: ["active", "Draft", "inactive"],
    codingLang: ["C", "C#", "C++", "Golang", "Java", "JavaScript", "Kotlin", "Python", "R", "Scala", "Swift"],
  },
  rolestatus: [],
  roletotalcount: [],
  rolemycount: [],
  roleallcount: [],
  invitefilter: {
    invitedBy: [],
    status: ["active", "inactive"],
    jobRoleCategory: ["Engineering / Development", "R&D / Architect", "Other (IT, Support, DevOps, QE)"],
    skills: [],
  },
  invitedetails: [],
  inviteListTotal: [],
  inviteUserTotal: [],
  inviteAllTotal: [],
  generateskill: [],
  invitestatus: [],
  rolematching: [],
  resetTest: [],
  generatedProfileData: {},
  downloadcr: {},
  CandidateProfile: null,
  CandidateProfileSuccess: null,
  CandidateProfileFailure: null,
  CandidateJobSpecificProfile: null,
  CandidateJobSpecificProfileSuccess: null,
  CandidateJobSpecificProfileFailure: null,
  inviteDetailsFailure: null,
  updateTimelineEvents: null,
  updateTimelineEventsSuccess: null,
  updateTimelineEventsFailure: null,
  candidateProfileReport: null,
  candidateProfileReportSuccess: null,
  candidateProfileReportFailure: null,
  profileMatchReport: null,
  profileMatchReportSuccess: null,
  profileMatchReportFailure: null,
  getQuesAnsByTrackingId: null,
  getQuesAnsByTrackingIdSuccess: null,
  getQuesAnsByTrackingIdFailure: null,
  codingSubmissionDetails: null,
  codingSubmissionDetailsSuccess: null,
  codingSubmissionDetailsFailure: null,
  getBehaviorSkills: null,
  getBehaviorSkillsSuccess: null,
  getBehaviorSkillsFailure: null,
};

// Set RoleFilter and InviterFilter Skills
let skills = [];

for (let skill in config.skills) {
  if (config.skills[skill].isRoleSkill) {
    skills.push(config.skills[skill].fullName);
  }
}

skills = [...new Set(skills.map((i) => i.toLowerCase().trim()))];

initialState["rolefilter"]["skills"] = [...skills.sort()];
initialState["invitefilter"]["skills"] = [...skills.sort()];

function role(state = initialState, action) {
  switch (action.type) {
    case roleTypes.INVITE_DETAILS:
      return {
        ...state,
        isroleLoading: true,
      };
    case roleTypes.INVITE_DETAILS_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        invitedetails: action.payload,
        invitestatus: [],
        resetTest: [],
        expireDate: [],
        downloadcr: {},
        inviteDetailsFailure: null,
      };
    case roleTypes.INVITE_DETAILS_FAILURE:
      // console.log(action.payload,"add") // FK cleanup console july 2023
      return {
        ...state,
        isroleLoading: false,
        invitedetails: [],
        inviteDetailsFailure: action.payload,
        error: action.payload.error,
      };
    case roleTypes.DOWNLOAD_CR:
      return {
        ...state,
        isroleLoading: true,
        downloadcr: action.payload,
      };
    case roleTypes.DOWNLOAD_CR_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        downloadcr: action.payload,
      };
    case roleTypes.CANDIDATE_PROFILE:
      return {
        ...state,
        isroleLoading: true,
        CandidateProfile: action.payload,
      };
    case roleTypes.CANDIDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        CandidateProfileSuccess: action.payload,
      };
    case roleTypes.CANDIDATE_PROFILE_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        CandidateProfileFailure: action.payload,
      };
    case roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE:
      return {
        ...state,
        isroleLoading: true,
        CandidateJobSpecificProfile: action.payload,
      };
    case roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        CandidateJobSpecificProfileSuccess: action.payload,
      };
    case roleTypes.CANDIDATE_JOB_SPECIFIC_PROFILE_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        CandidateJobSpecificProfileFailure: action.payload,
      };
    case roleTypes.DOWNLOAD_REPORT_STATUS:
      return {
        ...state,
        isroleLoading: false,
        downloadcr: null,
      };
    case roleTypes.UPDATE_TIMELINE_EVENTS:
      return {
        ...state,
        isroleLoading: true,
        updateTimelineEvents: action.payload,
      };
    case roleTypes.UPDATE_TIMELINE_EVENTS_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        updateTimelineEventsSuccess: action.payload,
      };
    case roleTypes.UPDATE_TIMELINE_EVENTS_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        updateTimelineEventsFailure: action.payload,
      };
    case roleTypes.CLEAR_UPDATE_TIMELINE_EVENTS:
      return {
        ...state,
        isroleLoading: false,
        updateTimelineEventsSuccess: null,
      };

    case roleTypes.CANDIDATE_PROFILE_REPORT:
      return {
        ...state,
        isroleLoading: true,
        candidateProfileReport: action.payload,
      };
    case roleTypes.CANDIDATE_PROFILE_REPORT_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        candidateProfileReportSuccess: action.payload,
      };
    case roleTypes.CANDIDATE_PROFILE_REPORT_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        candidateProfileReportFailure: action.payload,
      };
    case roleTypes.PROFILE_MATCH_REPORT:
      return {
        ...state,
        isroleLoading: true,
        profileMatchReport: action.payload,
      };
    case roleTypes.PROFILE_MATCH_REPORT_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        profileMatchReportSuccess: action.payload,
      };
    case roleTypes.PROFILE_MATCH_REPORT_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        profileMatchReportFailure: action.payload,
      };

    case roleTypes.GET_QUES_ANS_BY_TRACKING_ID:
      return {
        ...state,
        isroleLoading: true,
        getQuesAnsByTrackingId: action.payload,
      };
    case roleTypes.GET_QUES_ANS_BY_TRACKING_ID_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        getQuesAnsByTrackingIdSuccess: action.payload,
      };
    case roleTypes.GET_QUES_ANS_BY_TRACKING_ID_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        getQuesAnsByTrackingIdFailure: action.payload,
      };

    case roleTypes.CODING_SUBMISSION_DETAILS:
      return {
        ...state,
        isroleLoading: true,
        codingSubmissionDetails: action.payload,
      };
    case roleTypes.CODING_SUBMISSION_DETAILS_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        codingSubmissionDetailsSuccess: action.payload,
      };
    case roleTypes.CODING_SUBMISSION_DETAILS_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        codingSubmissionDetailsFailure: action.payload,
      };

    case roleTypes.GET_BEHAVIOR_SKILLS:
      return {
        ...state,
        isroleLoading: true,
        getBehaviorSkills: action.payload,
      };
    case roleTypes.GET_BEHAVIOR_SKILLS_SUCCESS:
      return {
        ...state,
        isroleLoading: false,
        getBehaviorSkillsSuccess: action.payload,
      };
    case roleTypes.GET_BEHAVIOR_SKILLS_FAILURE:
      return {
        ...state,
        isroleLoading: false,
        getBehaviorSkillsFailure: action.payload,
      };

    default:
      return { ...state };
  }
}
export default role;
